module.exports = __webpack_public_path__ + "img/rosepetal-dev.32266c07.jpg";